<div class="page-main-header container-fluid">
    <div class="main-header-right row">
        <div class="main-header-left text-center col-lg-3">
            <div class="logo-wrapper">
                <a href="javascript:void(0)" routerLink="/">
                    <img src="assets/images/logo/NewLogo.png" alt="" /></a>
            </div>
        </div>
        <div class="col-lg-3"></div>
        <div class="main-header-left text-center col-lg-6">
            <div class="logo-wrapper">
                <a href="javascript:void(0)" routerLink="/">
                    <img src="assets/images/logo/logo2.png" alt="" /></a>
            </div>
        </div>
        <div class="mobile-sidebar">
            <div class="flex-grow-1 text-end switch-sm">
            </div>
        </div>
        <div class="vertical-mobile-sidebar">
            <i class="fa fa-bars sidebar-bar"> </i>
        </div>
        <div class="nav-right col pull-right right-menu">
            <div class="d-lg-none mobile-toggle pull-right">
                <app-feather-icons [icon]="'more-horizontal'" (click)="openMobileNav()"></app-feather-icons>
            </div>
        </div>
    </div>
</div>
<div class="card box-shadow mt-2">
    <div class="card-header h5 text-white bg-primary">
        <div class="row">
            <div class="col-10">
                <h4 class="heading text-2xl font-bold ms-5 mt-2 ff-robo">Demo Video</h4>
            </div>
            <div class="col-2">
                <button (click)="back()" class="btn btn-light text-dark float-right"><i class="fa fa-reply"></i>&nbsp;<b
                        class="ff-robo">Back</b></button>
            </div>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-1"></div>
        <div class="col-10 videoCenter">
            <iframe width="1000" height="600" [src]="getSafeUrl('https://youtu.be/VwlfnvgjA3k')" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen>
            </iframe>
        </div>
        <div class="col-1"></div>
    </div>
</div>